import React from "react";
import { Link } from "react-router-dom";
import { Users, Clock } from "lucide-react";

const fmtK = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}K` : `${n}`);

export function NearbyEventCard({ event }) {
  const isLive = event.status === "live";
  return (
    <Link
      to={`/event/${event.id}`}
      data-testid={`nearby-card-${event.id}`}
      className="group block w-[210px] shrink-0 overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-[16/11] overflow-hidden">
        <img
          src={event.thumbnail}
          alt={event.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-2.5 top-2.5 inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white ${
            isLive ? "bg-live" : "bg-brand"
          }`}
        >
          {isLive && <span className="h-1.5 w-1.5 rounded-full bg-white" />}
          {isLive ? "Live" : "Upcoming"}
        </span>
        {event.distanceKm != null && (
          <span className="absolute right-2.5 top-2.5 rounded-full bg-black/60 px-2.5 py-1 text-[11px] font-semibold text-white backdrop-blur-md">
            {event.distanceKm} km
          </span>
        )}
      </div>
      <div className="space-y-1 p-3.5">
        <h3 className="line-clamp-1 font-heading text-[15px] font-bold tracking-tight text-foreground">
          {event.title}
        </h3>
        <p className="line-clamp-1 text-xs text-muted-foreground">{event.city}</p>
        <p className="flex items-center gap-1.5 pt-1 text-xs font-medium text-muted-foreground">
          {isLive ? (
            <>
              <Users className="h-3.5 w-3.5" /> {fmtK(event.watching)} watching
            </>
          ) : (
            <>
              <Clock className="h-3.5 w-3.5 text-brand" /> {event.time}
            </>
          )}
        </p>
      </div>
    </Link>
  );
}

export default NearbyEventCard;
